import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/author/mark-portrait.jpg")